/**
 * @author Billy Kang <billy@nurigo.net>
 * @description 세금계산서의 API
 */
const axios = require('axios')
const qs = require('querystring')
export const getInvoiceList = payload =>
  axios.get(`/cash/v1/admin/taxinvoice?${qs.stringify(payload)}`)
